'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	if (typeof document !== 'undefined') {
		if (document.contains) {
			return document.contains;
		}
		if (document.body && document.body.contains) {
			return document.body.contains;
		}
	}
	return implementation;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/document.contains/polyfill.js
// module id = 521
// module chunks = 1